/*
Structured Output:
{
    percent_impervious: {
        min: float,
        max: float,
    },
    elevation: {
        min: float,
        max: float
    },
    soil_types: list[str]
}
*/

const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;

if (!OPENROUTER_API_KEY) {
    console.warn('Missing REACT_APP_OPENROUTER_API_KEY environment variable');
}
const queryLLM = async (prompt, systemPrompt) => {
  try {
    const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${OPENROUTER_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'google/gemini-2.5-pro',
        messages: [
          {
            role: 'system',
            content: systemPrompt
          },
          {
            role: 'user',
            content: prompt
          }
        ],
        response_format: {
          type: 'json_schema',
          json_schema: {
            name: 'lid_selection_criteria',
            strict: true,
            schema: {
              type: 'object',
              properties: {
                percent_impervious: {
                  type: 'object',
                  properties: {
                    min: { type: 'number' },
                    max: { type: 'number' }
                  },
                  required: ['min', 'max'],
                  additionalProperties: false
                },
                elevation: {
                  type: 'object',
                  properties: {
                    min: { type: 'number' },
                    max: { type: 'number' }
                  },
                  required: ['min', 'max'],
                  additionalProperties: false
                },
                soil_types: {
                  type: 'array',
                  items: { type: 'string' }
                }
              },
              required: ['percent_impervious', 'elevation', 'soil_types'],
              additionalProperties: false
            }
          }
        }
      })
    });

    if (!response.ok) {
      throw new Error(`OpenRouter API error: ${response.status}`);
    }

    const data = await response.json();

     //```json\n{\n  "percent_impervious": {\n    "min": -1,\n    "max": -1\n  },\n  "elevation": {\n    "min": -1,\n    "max": -1\n  },\n  "soil_types": ["Sand"]\n}\n```
      const content = data.choices[0].message.content;

      // Strip down to braces
      const jsonMatch = content.match("\\{.+\\}");
      const jsonString = jsonMatch ? jsonMatch[1].trim() : content;

      // Remove newlines
      const cleanedJson = jsonString.replace(/\\n/g, '');

      // Parse the extracted JSON
      console.log(cleanedJson);

      const parsedData = JSON.parse(cleanedJson);

      return parsedData;

  } catch (error) {
    console.error('Error querying LLM:', error);
    throw error;
  }
};

export default queryLLM;